import React from 'react';
import { styled } from '@linaria/react';
import { SelectedElement } from 'utils/selectedElement';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { OfferLayout } from '@daedalus/shared/src/search/OfferLayout';
const ViewAllWrapper = /*#__PURE__*/styled('span')({
  name: "ViewAllWrapper",
  class: "v1tno4jv",
  propsAsIs: false
});
export const MoreDealsButtonHorizontal = () => <OfferLayout dataId={SelectedElement.ShowAllDeals} variant="SecondaryWithoutRoomName" priceComponent={<ViewAllWrapper>
        <FormattedMessageWrapper id="hotelCard.viewAll" defaultMessage="View all" />
      </ViewAllWrapper>} providerLogoComponent={<Text variant="bodyXS">
        <FormattedMessageWrapper id="hotelCard.moreDeals" defaultMessage="More Deals" />
      </Text>} />;

require("./MoreDealsButtonHorizontal.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MoreDealsButtonHorizontal.tsx");